export default {
  title: '积分商城配置',
  productConfig: '商品配置',
};
